import Icon from '../components/Icon.vue'

Icon.register({
  cat: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M290.6 192c11.9 58.3 63.6 102.4 125.4 102.4 11.1 0 21.7-1.9 32-4.5v206.1c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-144l-128 96h32c17.7 0 32 14.3 32 32v16c0 8.8-7.2 16-16 16h-176c-35.3 0-64-28.7-64-64v-256c0-17.6-14.4-32-32-32-17.7 0-32-14.3-32-32s14.3-32 32-32c52.9 0 96 43.1 96 96v86c55.8-84 142.4-86 162.6-86zM448 96l64-64v134.4c0 53-43 96-96 96s-96-43-96-96v-134.4l64 64h64zM376 176c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM456 176c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cat.js
// module id = 1165
// module chunks = 0